import Shell from '../components/Shell';
import type { Branding } from '../types';

interface ProcessingPageProps {
  branding: Branding | null;
  title?: string;
}

// step === 'processing': neutral on purpose — it never hints at the verdict (D4).
export default function ProcessingPage({ branding, title = 'Estamos procesando tu información…' }: ProcessingPageProps) {
  return (
    <Shell branding={branding}>
      <div className="processing" role="status" aria-live="polite">
        <div className="spinner" aria-hidden="true" />
        <h1>{title}</h1>
        <p className="lead">Esto puede tardar unos segundos. No cierres esta ventana.</p>
      </div>
    </Shell>
  );
}
